<template>
	<b-form ref="signup_form" class="needs-validation">
		<b-card-group>
			<b-card>
				<h2>Stamoplysninger</h2>
				<b-form-group label="CVR-nr." horizontal breakpoint="lg" label-size="sm">
					<b-form-input v-model="cvr" size="sm" placeholder="f.eks. 12345678" @input="cvr_state = 'typing'" @blur="load_from_cvrapi(cvr)" />
					<span v-if="cvr_state == 'loading'">Henter oplysninger fra CVR-registeret...</span>
					<span v-else-if="cvr_state == 'invalid'">Dette CVR-nummer ser ikke ud til at være i brug</span>
				</b-form-group>
				<b-form-group label="Kontaktperson" horizontal breakpoint="lg" label-size="sm">
					<b-form-input v-model="contact" size="sm" placeholder="f.eks. Jens Hansen" />
				</b-form-group>
				<b-form-group label="Firmanavn" horizontal breakpoint="lg" label-size="sm">
					<b-input-group size="sm">
						<!-- <b-input-group-prepend is-text>
							Firmanavn
						</b-input-group-prepend> -->
						<b-form-input v-model="company_name" size="sm" placeholder="f.eks. 123 Vinduespudsning" />
					</b-input-group>
				</b-form-group>
				<b-form-group label="Adresse" horizontal breakpoint="lg" label-size="sm">
					<b-form-input v-model="address" @blur.native="guess_zip_and_city" size="sm" placeholder="f.eks. Strandvej 47" />
				</b-form-group>
				<b-form-group label="Postnr." horizontal breakpoint="lg" label-size="sm">
					<b-form-input v-model="zipcode" @blur.native="guess_city" size="sm" placeholder="f.eks. 6000" />
				</b-form-group>
				<b-form-group label="By" horizontal breakpoint="lg" label-size="sm">
					<b-form-input v-model="city" size="sm" placeholder="f.eks. Kolding" />
				</b-form-group>
				<b-form-group label="Telefon" horizontal breakpoint="lg" label-size="sm">
					<b-form-input v-model="phone" size="sm" placeholder="f.eks. 7734 0917" type="tel" />
				</b-form-group>
				<b-form-group label="E-mail" horizontal breakpoint="lg" label-size="sm">
					<b-form-input v-model="email" size="sm" placeholder="f.eks. mail@skvizbiz.dk" type="email" />
				</b-form-group>
			</b-card>
			<b-card>
				<h2>SkvizBiz tilvalg</h2>
				<b-form-group label="Kontotype" horizontal breakpoint="lg" label-size="sm">
					<b-form-select v-model="account_type" size="sm" value="demo"><option value="demo">Gratis 30-dages demo</option><option value="standard">Fuld version</option><option value="lite">Lite-udgaven</option></b-form-select>
				</b-form-group>
				<b-form-group :label="`Ekstra medarbejdere: ${employees}`" horizontal breakpoint="lg" label-size="sm">
					<b-form-input type="range" min="0" :max="max_employees" v-model="employees" />
					<!-- <b-form-spinbutton size="sm" min="0" :max="40" v-model="employees" inline style="margin-top: -.5em; margin-bottom: -.5em;" /> ekstra medarbejdere/logins -->
					<!-- <b-form-select v-model="employees" size="sm" value="1" :options="employee_options" /> -->
				</b-form-group>
				<b-form-group label="Finansmodul" horizontal breakpoint="lg" label-size="sm">
					<b-form-select v-model="finance" size="sm" value="1" :options="finance_options" />
				</b-form-group>
				<b-form-group label="Betalingsservice" horizontal breakpoint="lg" label-size="sm">
					<b-form-select v-model="pbs" size="sm" value="0" :options="[{value:1, text:'Ja tak'}, {value:0, text:'Nej tak'}]" />
				</b-form-group>
				<b-form-group label="Prisberegner" horizontal breakpoint="lg" label-size="sm">
					<b-form-select v-model="price_calculator" size="sm" value="0" :options="[{value:1, text:'Ja tak'}, {value:0, text:'Nej tak'}]" />
				</b-form-group>
				<b-form-group label="API-modul" horizontal breakpoint="lg" label-size="sm">
					<b-form-select v-model="api" size="sm" value="0" :options="[{value:1, text:'Ja tak'}, {value:0, text:'Nej tak'}]" />
				</b-form-group>
				<b-form-group label="Abonnementsperiode" horizontal breakpoint="lg" label-size="sm">
					<b-form-select v-model="period" size="sm" value="1" :options="[{value:1, text:'1 måned'}, {value:3, text:'3 måneder'}, {value:12, text:'12 måneder'}]" />
				</b-form-group>
				<b-form-group label="Evt. besked vedrørende bestillingen" horizontal breakpoint="lg" label-size="sm">
					<b-form-textarea size="sm" v-model="notes" rows="3" />
				</b-form-group>
			</b-card>
		</b-card-group>
		<div class="mt-3">
			<b-button variant="success" class="float-right" :disabled="sending_signup" @click="send_signup_request">Send bestilling nu</b-button>
		</div>
	</b-form>
</template>

<script>
import {
	BForm,
	BCardGroup,
	BCard,
	BFormGroup,
	BFormInput,
	// BFormSpinbutton,
	BInputGroup,
	BInputGroupPrepend,
	BFormSelect,
	BFormTextarea,
	BButton,
} from "bootstrap-vue";

import axios from "axios";

var decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
	var element;

	function decodeHTMLEntities (str) {
		if(str && typeof str === 'string') {
			if (!element) {
				element = document.createElement('div');
			}
			// strip script/html tags
			str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
			str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
			element.innerHTML = str;
			str = element.textContent;
			element.textContent = '';
		}

		return str;
	}

	return decodeHTMLEntities;
})();

export default {
	name: 'signup',
	props: [
		"_account_type",
		"_employees",
		"_finance",
		"_pbs",
		"_price_calculator",
		"_api",
		"_period",
	],
	components: {
		BForm,
		BCardGroup,
		BCard,
		BFormGroup,
		BFormInput,
		// BFormSpinbutton,
		BInputGroup,
		BInputGroupPrepend,
		BFormSelect,
		BFormTextarea,
		BButton,
	},
	data: function(){return {
		company_name: "",
		contact: "",
		address: "",
		zipcode: "",
		city: "",
		phone: "",
		email: "",
		cvr: "",
		cvr_state: "typing",
		account_type: "demo",
		employees: 0,
		finance: 1,
		pbs: 0,
		price_calculator: 0,
		api: 0,
		period: 1,
		notes: "",
		sending_signup: false,
	}},
	computed: {
		max_employees() {
			if (this.account_type == 'lite') {
				return 0;
			}
			return 40;
		},
		employee_options() {
			if (this.account_type == 'lite') {
				return [{value:1, text:'Ingen (kun 1 login)'}];
			}
			return [
				{value:1, text:'Ingen (kun 1 login)'},
				{value:5, text:'Op til 5'},
				{value:10, text:'Op til 10'},
				{value:15, text:'Op til 15'},
				{value:20, text:'Op til 20'},
				{value:25, text:'Op til 25'},
				{value:30, text:'Op til 30'},
				{value:35, text:'Op til 35'},
				{value:40, text:'Op til 40'},
				{value:'more', text:'Mere end 40 (noter hvor mange i beskedfeltet)'}
			];
		},
		finance_options() {
			return [{value:1, text:'Ja tak'}];
		},
		inputValid() {
			this.company_name;
			this.contact;
			this.address;
			this.zipcode;
			this.city;
			this.phone;
			this.email;
			this.cvr;
			this.account_type;
			this.employees;
			this.finance;
			this.pbs;
			this.price_calculator;
			this.notes;

			let $form = this.$refs.signup_form;
			if (!$form.checkValidity || $form.checkValidity()) {
				return true;
			}
			return false;
		},
	},
	mounted() {
		this.inherit_options();
	},
	methods: {
		async guess_zip_and_city() {
			if (this.address.length < 3) {
				return;
			}
			try {
				let data = await axios.get(`https://dawa.aws.dk/adresser?q=${this.address}&struktur=mini`).then(response=>response.data);
				if (data.length == 1) {
					this.zipcode = data[0].postnr;
					this.city = data[0].postnrnavn;
				}
			} catch (err) {}
		},
		async guess_city() {
			if (this.zipcode.length != 4) {
				return;
			}
			try {
				let data = await axios.get(`https://dawa.aws.dk/postnumre?nr=${this.zipcode}`).then(response=>response.data);
				if (data.length) {
					this.city = data[0].navn;
				}
			} catch (err) {}
		},
		async load_from_cvrapi(vat_number) {
			try {
				setTimeout(()=>{
					if (this.cvr_state == "typing") {
						this.cvr_state = "loading";
					}
				}, 250);
				let data = await axios.get(`https://cvrapi.dk/api?country=dk&version=6&vat=${vat_number}`).then(response=>response.data);
				if (data.error) {
					throw new Error(data.error);
				}
				this.cvr_state = "loaded";
	
				if (!this.company_name) {
					this.company_name = data.name;
				}
				// if (!this.contact) {
				// 	this.contact = data.;
				// }
				if (!this.address) {
					this.address = data.address;
				}
				if (!this.zipcode) {
					this.zipcode = data.zipcode;
				}
				if (!this.city) {
					this.city = data.city;
				}
				if (!this.phone) {
					this.phone = data.phone;
				}
				if (!this.email) {
					this.email = data.email;
				}
			} catch (err) {
				this.cvr_state = "invalid";
				err;
			}

			// "vat": 37243221,
			// "address": "Dyrehavegårdsvej 17",
			// "zipcode": 6000,
			// "city": "Kolding",
			// "cityname": null,
			// "protected": true,
			// "phone": 77340917,
			// "email": null,
			// "fax": null,
			// "startdate": "16/11 - 2015",
			// "enddate": null,
			// "employees": null,
			// "addressco": null,
			// "industrycode": 631100,
			// "industrydesc": "Databehandling, webhosting og lignende serviceydelser",
			// "companycode": 80,
			// "companydesc": "Anpartsselskab",
			// "creditstartdate": null,
			// "creditbankrupt": false,
			// "creditstatus": null,
			// "owners": null,
		},
		inherit_options() {
			if (typeof this._account_type !== "undefined") {
				this.account_type = this._account_type || "demo";
			}
			if (typeof this._employees !== "undefined") {
				this.employees = this._employees || 0;
			}
			if (typeof this._finance !== "undefined") {
				this.finance = +!!this._finance;
			}
			if (typeof this._pbs !== "undefined") {
				this.pbs = +!!this._pbs;
			}
			if (typeof this._price_calculator !== "undefined") {
				this.price_calculator = +!!this._price_calculator;
			}
			if (typeof this._api !== "undefined") {
				this.api = +!!this._api;
			}
			this.period = this._period || 1;
			// this.notes = this._period == "12" ? "Årsfakturering\n" : (this._period == "3" ? "Kvartalsfakturering\n" : (this._period == "1" ? "Månedsfakturering\n" : ""));
		},
		send_signup_request() {
			if (!this.inputValid) {
				return alert("Det ser ud til at du ikke har udfyldt alle oplysningerne.");
			}

			if (this.sending_signup == true) {
				return;
			}

			this.sending_signup = true;

			let data = JSON.parse(JSON.stringify(this.$data));

			// axios.post("http://newskvizbiz/signup_request.php", this.$data).then(data=>data.data.response).then((data) => {
			axios.post("https://secure.skvizbiz.dk/signup_request.php", data).then(data=>data.data.response).then((data) => {
				if (data.message) {
					alert(data.message);
				}
				// console.log(data)
				this.$emit("submitted");
				this.sending_signup = false;
			}, err => {
				this.sending_signup = false;
				// console.log(err);
				if (err.response.data.response.message) {
					// console.log(err.response.data.response);
					alert(decodeEntities(err.response.data.response.message));
				}
			})
		},
	},
	watch: {
		_account_type(newVal) {
			this.account_type = newVal;
		},
		account_type(newVal) {
			if (newVal == 'lite') {
				this.employees = 0;
				this.finance = 1;
			}
		},
		_employees(newVal) {
			this.employees = newVal;
		},
		_finance(newVal) {
			this.finance = +!!newVal;
		},
		_pbs(newVal) {
			this.pbs = +!!newVal;
		},
		_price_calculator(newVal) {
			this.price_calculator = +!!newVal;
		},
		_api(newVal) {
			this.api = +!!newVal;
		},
		// Før også årsfakturering/kvartals... med over
		_period(newVal) {
			this.period = +newVal;
			// this.notes = newVal == "12" ? "Årsfakturering\n" : (newVal == "3" ? "Kvartalsfakturering\n" : (newVal == "1" ? "Månedsfakturering\n" : ""));
		},
	},
}
</script>

<style>

</style>
